import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import ReactLightbox from 'react-image-lightbox';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
const Lightbox = _ref => {
  let _ref$style = _ref.style,
    style = _ref$style === void 0 ? {
      width: '100%',
      marginBottom: '0px'
    } : _ref$style,
    images = _ref.images,
    selectedIndex = _ref.selectedIndex,
    _ref$enableZoom = _ref.enableZoom,
    enableZoom = _ref$enableZoom === void 0 ? false : _ref$enableZoom;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    lightboxVisible = _useState2[0],
    toggleLightbox = _useState2[1];
  const _useState3 = useState(selectedIndex),
    _useState4 = _slicedToArray(_useState3, 2),
    index = _useState4[0],
    setIndex = _useState4[1];
  const displayLightbox = () => {
    toggleLightbox(!lightboxVisible);
    setIndex(selectedIndex); // always reset the index to selected on open/close
  };
  const calculateIndex = direction => (index + images.length + direction) % images.length;
  return /*#__PURE__*/React.createElement("div", null, lightboxVisible ? /*#__PURE__*/React.createElement(ReactLightbox, {
    mainSrc: images[index],
    nextSrc: images.length > 1 ? images[calculateIndex(+1)] : null,
    prevSrc: images.length > 1 ? images[calculateIndex(-1)] : null,
    onMoveNextRequest: () => setIndex(calculateIndex(+1)),
    onMovePrevRequest: () => setIndex(calculateIndex(-1)),
    onCloseRequest: displayLightbox,
    animationOnKeyInput: true // animate transition when using arrows
    ,
    reactModalStyle: {
      overlay: {
        zIndex: 2000
      }
    } // footer is 1030
    ,
    enableZoom: enableZoom
  }) : '', /*#__PURE__*/React.createElement("div", {
    tabIndex: "0",
    role: "button",
    onClick: displayLightbox,
    onKeyPress: displayLightbox,
    className: "t-lightbox-".concat(selectedIndex)
  }, /*#__PURE__*/React.createElement("img", {
    alt: "img",
    src: images[selectedIndex],
    style: style,
    className: "t-thumbnail-".concat(selectedIndex)
  })));
};
Lightbox.propTypes = {
  selectedIndex: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  style: PropTypes.shape({}),
  enableZoom: PropTypes.bool
};
export default Lightbox;